import { Component, Input } from '@angular/core';
import { IntegrationType } from '@pdqdev/pdq-shared/dist/entities';

@Component({
  selector: 'integration-details-overview',
  templateUrl: './integration-details-overview.component.html',
  styleUrls: ['./integration-details-overview.component.scss'],
  standalone: false,
})
export class IntegrationDetailsOverviewComponent {
  @Input() integrationType: IntegrationType;
  constructor() {}

  isArray(element) {
    const isArr = Array.isArray(element);
    return isArr;
  }
}
